<template>
  <v-card class="pl-5 pr-5">
    <h1>View My Publications</h1>
    <v-divider></v-divider>
    <v-tabs v-model="publicationTab">
      <v-tabs-slider></v-tabs-slider>

      <v-tab>
        Collections (Subscriptions)
      </v-tab>

      <v-tab>
        eBooks (Purchases)
      </v-tab>

      <v-tab>
        eBooks (Rentals)
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="publicationTab">
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-data-table
              :headers="subscription_headers"
              hide-default-footer
              :items="mockData"
            >
              <template v-slot:item.Id="props">
                <div>
                  <a @click="props.item.ShowMore=true">More Details</a>
                  <v-dialog :value="props.item.ShowMore" width="800" @click:outside="props.item.ShowMore=false">
                    <v-card>
                      <v-card-title class="text-h5 grey lighten-2">
                        Publication Details
                      </v-card-title>

                      <v-card-text>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua. Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ea
                        commodo consequat. Duis aute irure dolor in
                        reprehenderit in voluptate velit esse cillum dolore eu
                        fugiat nulla pariatur. Excepteur sint occaecat cupidatat
                        non proident, sunt in culpa qui officia deserunt mollit
                        anim id est laborum.
                      </v-card-text>

                      <v-divider></v-divider>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="props.item.ShowMore = false" id="btnShowMore">
                          Close
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
              </template>
            </v-data-table>
            <v-row>
              <v-col cols="12">
                <Pagination
                  :paging="paging_subscription"
                  v-on:next="onNextSubscription"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-data-table
              :headers="subscription_headers"
              hide-default-footer
              :items="mockData"
            >
            </v-data-table>
            <v-row>
              <v-col cols="12">
                <Pagination
                  :paging="paging_subscription"
                  v-on:next="onNextSubscription"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text
            ><v-data-table
              :headers="subscription_headers"
              hide-default-footer
              :items="mockData"
            >
            </v-data-table>
            <v-row>
              <v-col cols="12">
                <Pagination
                  :paging="paging_subscription"
                  v-on:next="onNextSubscription"
                />
              </v-col> </v-row
          ></v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import Pagination from "@/components/Pagination";
import * as api from "@/api";
import axios from "axios";
import moment from "moment";
import lodash from "lodash";
export default {
  components: {
    Pagination
  },
  data() {
    return {
      publicationTab: 1,
      subscription_headers: [
        {
          text: "ISBN",
          align: "start",
          sortable: false,
          value: "ISBN"
        },
        {
          text: "Title",
          align: "start",
          sortable: false,
          value: "Title"
        },
        {
          text: " Contributor (Author)",
          align: "start",
          sortable: false,
          value: "Author"
        },
        {
          text: "Publisher",
          align: "start",
          sortable: false,
          value: "Publisher"
        },
        {
          text: "Number of Copies",
          align: "start",
          sortable: false,
          value: "NumberofCopies"
        },
        {
          text: "Start Date",
          align: "start",
          sortable: false,
          value: "Start Date"
        },
        {
          text: "End Date",
          align: "start",
          sortable: false,
          value: "EndDate"
        },
        {
          text: "More Details",
          align: "start",
          sortable: false,
          value: "Id"
        }
      ],
      paging_subscription: { count: 10, page: 1, size: 10, keyword: "" },
      Purchases_headers: [
        {
          text: "ISBN",
          align: "start",
          sortable: false,
          value: "ISBN"
        },
        {
          text: "Title",
          align: "start",
          sortable: false,
          value: "Title"
        },
        {
          text: " Contributor (Author)",
          align: "start",
          sortable: false,
          value: "Author"
        },
        {
          text: "Publisher",
          align: "start",
          sortable: false,
          value: "Publisher"
        },
        {
          text: "Number of Copies",
          align: "start",
          sortable: false,
          value: "NumberofCopies"
        },
        {
          text: "Start Date",
          align: "start",
          sortable: false,
          value: "Start Date"
        },
        {
          text: "End Date",
          align: "start",
          sortable: false,
          value: "EndDate"
        }
      ],
      paging_Purchases: { count: 10, page: 1, size: 10, keyword: "" },
      Purchases_headers: [
        {
          text: "ISBN",
          align: "start",
          sortable: false,
          value: "ISBN"
        },
        {
          text: "Title",
          align: "start",
          sortable: false,
          value: "Title"
        },
        {
          text: " Contributor (Author)",
          align: "start",
          sortable: false,
          value: "Author"
        },
        {
          text: "Publisher",
          align: "start",
          sortable: false,
          value: "Publisher"
        },
        {
          text: "Number of Copies",
          align: "start",
          sortable: false,
          value: "NumberofCopies"
        },
        {
          text: "Start Date",
          align: "start",
          sortable: false,
          value: "Start Date"
        },
        {
          text: "End Date",
          align: "start",
          sortable: false,
          value: "EndDate"
        }
      ],
      paging_Rentals: { count: 10, page: 1, size: 10, keyword: "" },
      Rental_headers: [
        {
          text: "ISBN",
          align: "start",
          sortable: false,
          value: "ISBN"
        },
        {
          text: "Title",
          align: "start",
          sortable: false,
          value: "Title"
        },
        {
          text: " Contributor (Author)",
          align: "start",
          sortable: false,
          value: "Author"
        },
        {
          text: "Publisher",
          align: "start",
          sortable: false,
          value: "Publisher"
        },
        {
          text: "Number of Copies",
          align: "start",
          sortable: false,
          value: "NumberofCopies"
        },
        {
          text: "Start Date",
          align: "start",
          sortable: false,
          value: "Start Date"
        },
        {
          text: "End Date",
          align: "start",
          sortable: false,
          value: "EndDate"
        }
      ],
      mockData: [
        {
          Id: 1,
          ISBN: "ISBN-10001",
          Title: "Book Title",
          Author: "Author",
          Publisher: "Publisher",
          ShowMore: false
        }
      ]
    };
  },
  methods: {
    onNextSubscription() {},
    loadSubscription() {
      new Promise((resolve, reject) => {
        api
          .getAll("organization-collection/2")
          .then(response => {
            console.log(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  },
  mounted() {
    this.loadSubscription();
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Organization/OrgViewMyPublications.vue